import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { AiFillDelete } from 'react-icons/ai';
import { FaEye } from 'react-icons/fa';
import Navbar from '../../components/Navbar';
import ld from '../../images/load.gif';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '../../styles/allorders.module.css';

function AllOrders() {
  const [data, setData] = useState(null);
  const [id, setId] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getData = async () => {
    try {
      setLoading(true);
      let endpoint = '';
      
      if (id === 'pending') {
        endpoint = 'https://pro-shop-backend.vercel.app/api/orders/allorders/pending';
      } else if (id === 'confirmed') {
        endpoint = 'https://pro-shop-backend.vercel.app/api/orders/allorders/confirmed';
      } else if (id === 'processing') {
        endpoint = 'https://pro-shop-backend.vercel.app/api/orders/allorders/processing';
      } else if (id === 'shipped') {
        endpoint = 'https://pro-shop-backend.vercel.app/api/orders/allorders/shipped';
      } else if (id === 'delivered') {
        endpoint = 'https://pro-shop-backend.vercel.app/api/orders/allorders/delivered';
      } else if (id === 'cancelled') {
        endpoint = 'https://pro-shop-backend.vercel.app/api/orders/allorders/cancelled';
      } else {
        setLoading(false);
        toast.error('Invalid order type', {
          position: 'bottom-right',
          theme: 'colored'
        });
        return;
      }

      const res = await axios.get(endpoint);
      if (res.data.success === true) {
        setData(res.data.message);
      } else {
        toast.error(res.data.message || 'Failed to fetch orders', {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message || 'Failed to fetch orders. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const orderType = queryParams.get('orders');
    setId(orderType || '');
  }, [location.search]);

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  const getPageTitle = () => {
    switch(id) {
      case 'pending':
        return 'Pending Orders';
      case 'confirmed':
        return 'Confirmed Orders';
      case 'processing':
        return 'Processing Orders';
      case 'shipped':
        return 'Shipped Orders';
      case 'delivered':
        return 'Delivered Orders';
      case 'cancelled':
        return 'Cancelled Orders';
      default:
        return 'Orders';
    }
  };

  const getStatusBadgeClass = (status) => {
    switch(status) {
      case 'pending':
        return styles.statusPending;
      case 'confirmed':
        return styles.statusConfirmed;
      case 'processing':
        return styles.statusProcessing;
      case 'shipped':
        return styles.statusShipped;
      case 'delivered':
        return styles.statusDelivered;
      case 'cancelled':
        return styles.statusCancelled;
      default:
        return styles.statusPending;
    }
  };

  return (
    <div className={styles.allOrdersContainer}>
      <Navbar />
      
      <div className={styles.allOrdersContent}>
        <div className={styles.headerSection}>
          <div className={styles.headerLeft}>
            <h3 className={styles.pageTitle}>{getPageTitle()}</h3>
            <span className={styles.orderCount}>
              {data ? `${data.length} orders found` : 'Loading...'}
            </span>
          </div>
          <button
            type="button"
            className={styles.backBtn}
            onClick={() => navigate('/admin')}
          >
            ← Back to Dashboard
          </button>
        </div>

        {loading ? (
          <div className={styles.loadingContainer}>
            <img src={ld} className={styles.loaderImage} alt="Loading..." />
          </div>
        ) : data && data.length > 0 ? (
          <div className={styles.tableWrapper}>
            <table className={styles.ordersTable}>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Date</th>
                  <th>Total</th>
                  <th>Payment</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((val, key) => (
                  <tr key={key} className={styles.tableRow}>
                    <td className={styles.orderId}>{val._id.slice(0, 8)}...</td>
                    <td className={styles.customerName}>{val.user?.name || 'N/A'}</td>
                    <td>{val.mobileNumber || 'N/A'}</td>
                    <td>{moment(val.createdAt).format('DD MMM YYYY')}</td>
                    <td className={styles.orderTotal}>
                      ${val.totalPrice}
                    </td>
                    <td>
                      <span className={val.isPaid ? styles.paidBadge : styles.unpaidBadge}>
                        {val.isPaid ? 'Paid' : 'Not Paid'}
                      </span>
                    </td>
                    <td>
                      <span className={`${styles.statusBadge} ${getStatusBadgeClass(val.status)}`}>
                        {val.status || 'pending'}
                      </span>
                    </td>
                    <td>
                      <button
                        onClick={() => navigate(`/order/${val._id}`)}
                        className={styles.detailsBtn}
                      >
                        <FaEye className={styles.detailsIcon} />
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={styles.noOrders}>
            <div className={styles.noOrdersIcon}>📋</div>
            <p>No {id} orders found</p>
            <button
              type="button"
              className={styles.backToDashboard}
              onClick={() => navigate('/admin')}
            >
              Back to Dashboard
            </button>
          </div>
        )}
      </div>

      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default AllOrders;